<template>
  <funnel-step-layout noScroll anchor="summary">
    <div id="simulation-header"><px-logo :link="$t('summary.logo_link')"></px-logo></div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-xs-12 mb-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{$t('summary.summary_title')}}</h5>
              <div class="card-text text-left">
                <ul class="summary-list">
                  <li>{{$t('summary.entity_label')}} {{$t(`step1.${entity}.label`)}}</li>
                  <li>{{$t(`summary.${selectedGoal}_label`)}} {{selectedObjectivesOrServices}}</li>
                  <li>{{$t('summary.locations_label')}} {{selectedLocations}}</li>
                  <li>{{$t('summary.duration_label')}} {{$t(`step4.months.${inputs.duration}`)}}</li>
                  <!-- <li>{{$t('summary.audience_label')}}</li> -->
                </ul>
                <div class="row">
                  <div id="audienceCard" class="card bg-primary text-white shadow-sm col-xs-10 col-sm-8 mr-auto ml-auto mt-3 mb-3 p-2 justify-content-center align-items-center">
                    <div>{{$t('summary.audience_label')}}</div>
                    <strong v-if="audience.type === 'message'" class="audience-value">{{$t(audience.value)}}</strong>
                    <div v-if="audience.type !== 'message'">
                      {{$t('common.from')}} <strong class="audience-value">{{audience.minor}}</strong> {{$t('common.to')}} <strong class="audience-value">{{audience.value}}</strong>
                    </div>
                    <div v-if="audience.type !== 'message'">{{$t(`summary.potential_customers`)}}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-center mb-3 d-flex justify-content-center align-items-center">
                    <div v-if="displayBoostpack" v-b-popover.click="$t('summary.boost_pack_info')" class="boost_pack mt-2">
                      {{$t('summary.boost_pack')}} <i class="ml-2 fa fa-info-circle"></i>
                    </div>
                  </div>
                </div>
              </div>
              <px-button @click="openMobilePopin" class="discover-cta" type="cta" :text="$t('summary.callme_cta')"></px-button>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="row">
            <div class="col-12">
              <iframe v-if="hasVideoURL" id="ytplayer" type="text/html" width="100%" height="340" :src="$t('common.video')" frameborder="0"/>
            </div>
            <div v-if="hasSocialsNetwork" class="col-12 mt-3">
              {{$t('summary.follow_us')}} :
              <span class="align-middle" v-for="(socialURL, id) in structure.socials"
                :key="id">
                <a v-if="socialURL" :href="socialURL" rel="noindex, nofollow" target="_blank"><i :class="['social-network-icon', getSNIcon(id)]"></i></a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div id="zsiqwidget"></div>
    </div>
    <b-modal :hide-footer="true" ref="mobilePopin" id="callme" :title="$t('summary.popin_callme.title')">
      <div class="form-group text-left">
        <label for="phoneInput">{{$t('summary.popin_callme.label_phone')}}</label>
        <input id="phoneInput" :class="[ 'form-control', {'is-valid' : !$v.phone.$invalid }, { 'is-invalid' : $v.phone.$invalid && $v.phone.$dirty }]" type="tel" name="phone" :value="phone" @input="updatePhone" />
        <div class="invalid-feedback" v-if="$v.phone.$dirty && !$v.phone.phoneNumber">{{$t('summary.popin_callme.error_phone_bad')}}</div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <el-date-picker format="dd-MM-yyyy" value-format="dd-MM-yyyy" style="width:100%" align="center" v-model="dateMeeting" :picker-options="datepickerOptions" type="date" :placeholder="$t('summary.popin_callme.date_placeholder')" ></el-date-picker>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-6">
          <button @click="selectMorning" :class="['btn-block','shadow-sm','btn',{'btn-primary-bs': dayPeriod === 'morning'}, {'btn-light': dayPeriod !== 'morning'}]" :disabled="!dateMeeting">{{$t('summary.popin_callme.morning')}}</button>
        </div>
        <div class="col-6">
          <button @click="selectEvening" :class="['btn-block','shadow-sm','btn',{'btn-primary-bs': dayPeriod === 'evening'}, {'btn-light': dayPeriod !== 'evening'}]" :disabled="!dateMeeting">{{$t('summary.popin_callme.evening')}}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 justify-content-center align-items-center">
          <px-button @click="sendContactMe" :text="$t('summary.popin_callme.cta')"></px-button>
        </div>
      </div>
    </b-modal>
    <!-- Modal : Cf /screens/Simulation.vue -->
  </funnel-step-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { FunnelStepLayout } from '@/components/Layouts'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { DatePicker } from 'element-ui'
import swal from 'sweetalert2'
import ContactService from '@/services/ContactService'
import store from '@/store'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

export default {
  name: 'audience-summary',
  components: {
    FunnelStepLayout,
    'b-modal': bModal,
    [DatePicker.name]: DatePicker
  },
  directives: {
    'b-modal': bModalDirective
  },
  mixins: [validationMixin],
  validations: {
    phone: {
      required,
      phoneNumber: (value) => {
        // eslint-disable-next-line
        const reg = /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/g
        if (reg.exec(value) !== null) {
          return true
        }
        return false
      }
    },
    dateMeeting: {
      required
    },
    dayPeriod: {
      required,
      morningOrEvening: (value) => value === 'morning' || value === 'evening'
    }
  },
  methods: {
    getSNIcon (network) {
      switch (network) {
        case 'youtube':
          return 'fab fa-youtube-square'
        case 'linkedin':
          return 'fab fa-linkedin'
        case 'instagram':
          return 'fab fa-instagram'
        case 'twitter':
          return 'fab fa-twitter-square'
        case 'facebook':
          return 'fab fa-facebook'
        default:
      }
    },
    updatePhone (e) {
      this.$store.dispatch('session/updatePhone', e.target.value)
    },
    openMobilePopin () {
      this.$refs.mobilePopin.show()
    },
    sendContactMe () {
      this.$v.$touch()
      if (this.meetingDone) {
        return this.$notify({message: this.$t('summary.popin_callme.meeting_already_programmed'),
          type: 'info',
          horizontalAlign: 'center',
          verticalAlign: 'bottom'
        })
      }
      if (!this.$v.$invalid) {
        ContactService.sendContactMe({contactInfos: this.contactInfos, lang: this.lang, dateMeeting: this.dateMeeting, dayPeriod: this.dayPeriod}).then(response => {
          if (response.data.success) {
            this.$refs.mobilePopin.hide()
            this.meetingDone = true
            this.$notify({message: this.$t('summary.popin_callme.success_meeting'),
              type: 'success',
              horizontalAlign: 'center',
              verticalAlign: 'bottom'
            })
          } else {
            this.$notify({message: this.$t('summary.popin_callme.error_meeting'),
              type: 'danger',
              horizontalAlign: 'center',
              verticalAlign: 'bottom'
            })
          }
        }).catch(() => {
          this.$notify({message: this.$t('summary.popin_callme.error_meeting'),
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'bottom'
          })
        })
      }
    },
    selectMorning () {
      this.dayPeriod = 'morning'
    },
    selectEvening () {
      this.dayPeriod = 'evening'
    }
  },
  data () {
    return {
      meetingDone: false,
      dayPeriod: null,
      dateMeeting: null,
      datepickerOptions: {
        disabledDate (time) {
          const now = new Date()
          if (now.getDate() === time.getDate() &&
          now.getMonth() === time.getMonth() &&
          now.getYear() === time.getYear()) {
            return true
          }
          return time.getDay() === 0 ||
              time.getDay() === 6 ||
              (time.getTime() < now.getTime())
        },
        firstDayOfWeek: 1
      }
    }
  },
  computed: {
    ...mapGetters({
      structure: 'form/summary_structure',
      goal: 'form/goal',
      entity: 'form/entity',
      inputs: 'form/inputs',
      lang: 'lang',
      audience: 'form/audience',
      contactInfos: 'session/contact_infos'
    }),
    ...mapState('session', {
      phone: state => state.user_phone
    }),
    hasVideoURL () {
      return this.$t('common.video').startsWith('http')
    },
    selectedObjectivesOrServices () {
      // const selected = []

      return this.inputs.objectives_services.map(id => this.$t(`step2.${this.entity}.${this.goal}.${id}.title`)).join(', ')

      // for (let i = 0; i < this.inputs.objectives_services.length; i++) {
      //   selected.push(this.$t(`step2.${this.entity}.${this.goal}.${this.inputs.objectives_services[i]}.title`))
      // }
      // return selected.join(', ')
    },
    selectedLocations () {
      // TODO: Refactor -> map().join() + limit (ex: + 34 villes)
      const locations = []
      for (let i = 0; i < this.inputs.locations.cities.length; i++) {
        locations.push(this.inputs.locations.cities[i][`name_${this.lang}`])
      }
      for (let i = 0; i < this.inputs.locations.countries.length; i++) {
        locations.push(this.inputs.locations.countries[i][`name_${this.lang}`])
      }
      return locations.join(', ')
    },
    selectedGoal () {
      if (this.goal === 'objectives') {
        return 'objective'
      }
      return 'service'
    },
    displayBoostpack () {
      if (this.inputs.features) {
        if (this.inputs.features.includes('video') ||
        this.inputs.features.includes('bannre')) {
          return false
        }
      }
      return true
    },
    hasSocialsNetwork () {
      if (this.structure.socials) {
        return Object.values(this.structure.socials).some(url => url.length)
      }
      return false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'homepage') {
      return next()
    } else {
      swal({
        title: this.$t('common.alerts.quit_summary.title'),
        text: this.$t('common.alerts.quit_summary.desc'),
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: 'rgb(240,148,39)',
        cancelButtonColor: 'rgb(204,204,204)',
        cancelButtonText: this.$t('common.alerts.quit_summary.cancel'),
        confirmButtonText: this.$t('common.alerts.quit_summary.yes')
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('form/reset')
          this.$router.replace({name: 'homepage'})
        }
      })
    }
    next(false)
  },
  beforeRouteEnter (to, from, next) {
    // check if data
    // if not => redirect to homepage
    if (!store.getters['form/can_display_summary']) {
      next({name: 'homepage'})
    }
    next()
  },
  mounted () {
    if (!window.$zoho) {
      var $zoho = $zoho || {}; $zoho.salesiq = $zoho.salesiq || { widgetcode: '42bc5e4b9fa6afeba5cdfddf7e4cfe078eb447aab3001ccbe2743c98874ddd21', values: {}, ready: function () {} }
      if (!document.getElementById('zsiqscript')) {
        var d = document; var s = d.createElement('script'); s.type = 'text/javascript'; s.id = 'zsiqscript'; s.defer = true; s.src = 'https://salesiq.zoho.com/widget'; var t = d.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t)
      }
      window.$zoho = $zoho
    }
  }
}
</script>
